export default __webpack_public_path__ + "static/media/invoices-icon.76d5bd24.svg";